<section class="container mt-5">


    <h1>Punto Fisico {{punto.numeroDocumento}} y {{punto.nombre}}</h1>
    <small>Boletas totales vendidas por el punto: {{punto.boletasVendidas.length}}</small> <br>
    <small>Dinero que vendio en boletas {{dineroTotalBoletas | currency:'COP'}}</small> <br>
    <button class="btn btn-warning" (click)="pagarBoletas()" >Pagar</button>

    <table class="table mt-3 contenedorLista">

        <thead>
            <tr>
                <th>Id</th>
                <th>Nombre del evento</th>
                <th>Localidad</th>
                <th>Precio</th>
       
        
             
                
            </tr>
    
    
    
        </thead>
        <tbody>
          
            <tr *ngFor = "let boleta of punto.boletasVendidas" class="filasEventos">
                <td>{{boleta?.id}}</td>
                <td>{{boleta.nombreEvento}}</td>
                <td>{{boleta.localidadNombre}}</td>
                <td>{{boleta?.precio + boleta?.servicio  + boleta?.servicioIva| currency: 'COP'}}</td>


 
    
            </tr>
    
    
        </tbody>
    
    </table>
    
</section>


<section class="container mt-5">


    <h1>Historial Boletas Punto Fisico {{punto.numeroDocumento}} y {{punto.nombre}}</h1>
    <small>Boletas total historico vendidas por el punto: {{punto.boletasCanjeadas.length}}</small> <br>
   

    <table class="table mt-3 contenedorLista">

        <thead>
            <tr>
                <th>Id</th>
                <th>Nombre del evento</th>
                <th>Localidad</th>
                <th>Precio</th>
       
        
             
                
            </tr>
    
    
    
        </thead>
        <tbody>
          
            <tr *ngFor = "let boleta of punto.boletasCanjeadas" class="filasEventos">
                <td>{{boleta?.id}}</td>
                <td>{{boleta.nombreEvento}}</td>
                <td>{{boleta.localidadNombre}}</td>
                <td>{{boleta?.precio + boleta?.servicio +boleta?.servicio*IVA| currency: 'COP'}}</td>


 
    
            </tr>
    
    
        </tbody>
    
    </table>
    
</section>



<section class="container mt-5 contenedorLista">


    <h1>Punto Fisico {{punto.numeroDocumento}} y {{punto.nombre}}</h1>
    <small>Palcos totales vendidas por el punto: {{punto.palcosVendidos.length}}</small> <br>
    <small>Dinero que vendio en palcos {{dineroTotalPalcos | currency:'COP'}}</small> <br>
    <button class="btn btn-warning" (click)="pagarPalcos()" >Pagar</button>

    <table class="table mt-3">

        <thead>
            <tr>
                <th>Id</th>
                <th>Nombre del evento</th>
                <th>Localidad</th>
                <th>Precio</th>
                <th>Precio pagado</th>
        
             
                
            </tr>
    
    
    
        </thead>
        <tbody>
          
            <tr *ngFor = "let palco of punto.palcosVendidos" class="filasEventos">
                <td>{{palco?.id}}</td>
                <td>{{palco.nombreEvento}}</td>
                <td>{{palco.nombre}}</td>
                <td>{{palco?.precio + palco?.servicio +palco?.servicio*IVA| currency: 'COP'}}</td>
                <td>{{palco?.precioParcialPagado| currency: 'COP'}}</td>

 
    
            </tr>
    
    
        </tbody>
    
    </table>
    
</section>

<section class="container mt-5">


    <h1>Historial Palcos Punto Fisico {{punto.numeroDocumento}} y {{punto.nombre}}</h1>
    <small>Palcos total Historico vendidas por el punto: {{punto.palcosCanjeados.length}}</small> <br>


    <table class="table mt-3 contenedorLista">

        <thead>
            <tr>
                <th>Id</th>
                <th>Nombre del evento</th>
                <th>Localidad</th>
                <th>Precio</th>
                <th>Precio pagado</th>
        
             
                
            </tr>
    
    
    
        </thead>
        <tbody>
          
            <tr *ngFor = "let palco of punto.palcosCanjeados" class="filasEventos">
                <td>{{palco?.id}}</td>
                <td>{{palco.nombreEvento}}</td>
                <td>{{palco.nombre}}</td>
                <td>{{palco?.precio + palco?.servicio +palco?.servicio*IVA| currency: 'COP'}}</td>
                <td>{{palco?.precioParcialPagado| currency: 'COP'}}</td>

 
    
            </tr>
    
    
        </tbody>
    
    </table>
    
</section>
